import React, { useEffect, useState, useContext } from "react";
import { useConfirmation } from "../../Context/ConfirmationContext";
import listTableStyles from "../../styles/ListTable.module.css";
import axios from "axios";
import { saveAs } from "file-saver";
import { useDispatch } from "react-redux";
import styles from "./Staff.module.css";
import moment from "moment";
import { useTimezone } from "../../Context/TimezoneContext";
import NoData from "../../components/svgIcons/NoData";
import PropTypes from "prop-types";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Paper,
  AppBar,
  Tabs,
  Tab,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  IconButton,
  Container,
  Button,
  Typography,
  useMediaQuery,
  TextField,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import { format } from "../../intl";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import GridOnIcon from "@material-ui/icons/GridOn";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { useSnackbar } from "../../utils/useSnackbar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { deleteStaff } from "../../actions/staffActions";
import { StaffCommissionDetailContext } from "../../Context/StaffCommissionDetailsContext";
import { useEffectiveProfile } from "../../utils/useEffectiveProfile";
import { getCurrencySymbol } from "../../utils/currency";
import { API_BASE, APP_URL } from "../../config";
import useReportExport from "../../components/ReportProgress/useReportExport";
import ReportProgress from "../../components/ReportProgress/ReportProgress";
import { exportRowsToExcel } from "../../components/Reports/exportExcel";
import { shareReportViaWhatsapp } from "../../components/Reports/whatsappShare";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
// import staff from '../../staff.json'

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: "16px",
  },
}));

const StaffCommission = ({ staff, staffCommissionDetails }) => {
  const { formatInTimezone } = useTimezone();
  const confirm = useConfirmation();
  const liveProfile = useEffectiveProfile();
  const currencySymbol = getCurrencySymbol(liveProfile?.currency);
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const {
    startDate,
    endDate,
    handleStartDateChange,
    handleEndDateChange,
    generate,
    handleGenerate,
    staffCommissionSummary,
  } = useContext(StaffCommissionDetailContext);
  const [loading, setLoading] = useState(false);
  const reportExport = useReportExport();
  useEffect(() => {
    setLoading(reportExport.isRunning);
  }, [reportExport.isRunning]);
  // eslint-disable-next-line
  const [currentTab, setCurrentTab] = useState(0);
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const history = useHistory();
  const dispatch = useDispatch();

  const [rows, setRows] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const handleStaffNameClick = (id) => {
  //   history.push(`/stats/${id}`);
  // };
  const handleEdit = (id) => {
    history.push(`/edit/staff/${id}`);
  };

  const handleDelete = async (id) => {
    const confirmDelete = await confirm({ title: "Delete staff member?", message: "This staff member will be permanently deleted." });
    if (confirmDelete) {
      dispatch(deleteStaff(id, openSnackbar));
    }
  };
  useEffect(() => {
    const rows = staff;
    setRows(rows);
  }, [rows]);
  // padding/fontSize/borderBottom now live in ListTable.module.css so every
  // list page shares one compact, colored look - keep only what that
  // shared class doesn't cover (layout width, cursor, alignment).
  const tableStyle = {
    width: 160,
    cursor: "pointer",
    textAlign: "center",
  };
  const headerStyle = { textAlign: "center" };
  // const filteredRows = rows?.filter((row) =>
  //   row.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );
  const handleStaffNameClick = (id) => {
    history.push(`/staffstats/${id}`);
  };

  const buildCommissionPdfConfig = () => ({
    label: "Commission summary",
    create: () =>
      axios.post(`${API_BASE}/create-commission-summary-report`, {
        staffCommissionSummary,
        startDate: moment(startDate).format(" MMM DD, YYYY"),
        endDate: moment(endDate).format(" MMM DD, YYYY"),
        currency: currencySymbol,
      }),
    fetch: () =>
      axios.get(`${API_BASE}/fetch-commission-summary-report`, {
        responseType: "blob",
      }),
    fileName: `CommissionSummaryReport_${formatInTimezone(new Date(), "YYYY-MM-DD_HHmm")}.pdf`,
  });
  const commissionPdfUrl = `${APP_URL}/files/Exported-Commission-Summary-Reports/commissionsummaryreport.pdf`;

  const createAndDownloadPdf = () => {
    if (!staffCommissionSummary.length) {
      openSnackbar("No record to Export");
      return;
    }
    reportExport.run({ ...buildCommissionPdfConfig(), openUrl: commissionPdfUrl });
  };

  const downloadExcel = () => {
    if (!staffCommissionSummary.length) {
      openSnackbar("No record to Export");
      return;
    }
    exportRowsToExcel({
      currencySymbol,
      fileNamePrefix: "CommissionSummaryReport",
      sheetName: "Commission",
      headers: ["Staff", "Total Commission"],
      rows: staffCommissionSummary.map((row) => [row.name || "", row.totalCommission || 0]),
    });
  };

  const shareWhatsapp = () => {
    if (!staffCommissionSummary.length) {
      openSnackbar("No record to Export");
      return;
    }
    shareReportViaWhatsapp(reportExport, { ...buildCommissionPdfConfig(), pdfUrl: commissionPdfUrl });
  };
  return (
    <div className={styles.pageLayout}>
      <Container style={{ width: isMobile ? "100%" : "75%" }}>
        <Paper elevation={3}>
          <Container>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="From"
                  name="FromDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                  required
                  format="MMM dd, yyyy"
                  style={{ maxWidth: isMobile ? "50%" : "100%" }}
                />

                <KeyboardDatePicker
                  label="To"
                  name="EndDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  required
                  format="MMM dd, yyyy"
                  style={{ maxWidth: "50%" }}
                />
              </MuiPickersUtilsProvider>
              <Button
                variant="outlined"
                style={{
                  margin: "16px 0 8px 0",
                  height: "50px",
                }}
                onClick={() => handleGenerate(rows, staffCommissionDetails)}
              >
                Generate
              </Button>
              {loading ? (
                <CircularProgress
                  style={{ marginTop: "20px", marginLeft: "10px" }}
                />
              ) : (
                <Tooltip title="Download this list as a PDF" arrow>
                  <Button
                    disabled={!endDate}
                    variant="outlined"
                    endIcon={<PictureAsPdfIcon style={{ color: "#c0392b" }} />}
                    onClick={createAndDownloadPdf}
                    style={{
                      margin: "16px 0 8px 0",
                      height: "50px",
                    }}
                  >
                    PDF
                  </Button>
                </Tooltip>
              )}
              {!loading && (
                <Tooltip title="Download this list as an Excel spreadsheet" arrow>
                  <Button
                    variant="outlined"
                    endIcon={<GridOnIcon style={{ color: "#217346" }} />}
                    onClick={downloadExcel}
                    style={{
                      margin: "16px 0 8px 0",
                      height: "50px",
                    }}
                  >
                    Excel
                  </Button>
                </Tooltip>
              )}
              {!loading && (
                <Tooltip title="Generate the PDF and share it on WhatsApp" arrow>
                  <IconButton
                    onClick={shareWhatsapp}
                    style={{
                      margin: "16px 0 8px 8px",
                      height: 50,
                      width: 50,
                      border: "1px solid #d8dee8",
                      borderRadius: 8,
                    }}
                  >
                    <WhatsAppIcon style={{ color: "#25D366" }} />
                  </IconButton>
                </Tooltip>
              )}
              <ReportProgress
                {...reportExport}
                onRetry={reportExport.retry}
                onClose={reportExport.reset}
              />
            </div>
          </Container>
        </Paper>
        {generate && (
          <div>
            <TableContainer component={Paper} elevation={0} className={`slim-scrollbar ${listTableStyles.container}`}>
              <Table
                className={classes.table}
                aria-label="custom pagination table"
              >
                <TableHead>
                  <TableRow className={listTableStyles.headRow}>
                    <TableCell style={{ ...headerStyle, width: "10px" }}>
                      Sr#
                    </TableCell>
                    <TableCell style={headerStyle}>Staff Name</TableCell>
                    {/* <TableCell style={headerStyle}>No of services</TableCell> */}
                    <TableCell style={headerStyle}>Total Commission</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? staffCommissionSummary?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : rows
                  ).map((row, index) => (
                    <TableRow key={row._id} className={listTableStyles.row} style={{ cursor: "context-menu" }}>
                      <TableCell
                        style={{
                          ...tableStyle,
                          width: "10px",
                          cursor: "context-menu",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell style={tableStyle} scope="row">
                        {" "}
                        <Button
                          style={{ textTransform: "none" }}
                          onClick={() => handleStaffNameClick(row._id)}
                        >
                          {" "}
                          {row.name}{" "}
                        </Button>
                      </TableCell>
                      <TableCell style={tableStyle} scope="row">
                        {" "}
                        <Button
                          style={{ textTransform: "none" }}
                          onClick={() => handleStaffNameClick(row._id)}
                        >
                          {" "}
                          {format(row.totalCommission, liveProfile?.currency)}{" "}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: "All", value: -1 },
                      ]}
                      colSpan={6}
                      count={staffCommissionSummary.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { "aria-label": "rows per page" },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
        )}
      </Container>
    </div>
  );
};

export default StaffCommission;
